import { of } from "rxjs";
import { tap, ignoreElements } from "rxjs/operators";
import { ofType, combineEpics } from "redux-observable";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { loadExpTemplatesActionTypes, loadingExpTemplates, loadedExpTemplates, loadFlightControlActionTypes, loadingFlightControl, loadedFlightControl, loadTrafficFiltersActionTypes, loadingTrafficFilters, loadedTrafficFilters, loadExperimentPrototypeActionTypes, loadingExperimentPrototype, loadedExperimentPrototype, createExperimentActionTypes, creatingExperiment, createdExperiment } from "./ExperimentCreateContainer.ducks.js";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import ExperimentResources from "@ane/exp-data/lib/resources/ExperimentResources";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import ExperimentUtils from "../../../Details/utils/ExperimentUtils.js";
const getExpTemplatesEpic = produceLoadLoadingLoadedEpic({
  filterOnType: loadExpTemplatesActionTypes.LOAD,
  loadResource: (payload) => {
    const experimentationGroup = getExperimentationGroupIdFromPath(payload.workspaceId, payload.managementGroup);
    return MdsDataplaneResources.getConfigWithTypeV2({
      // @ts-ignore
      workspaceId: payload.workspaceId,
      experimentationGroup,
      section: MasterDataConstants.experimentTemplates
    });
  },
  // @ts-ignore
  loadingAction: (payload) => loadingExpTemplates(payload.workspaceId, payload.managementGroup),
  loadedAction: (successData, payload, error) => {
    return of(loadedExpTemplates(payload.workspaceId, payload.managementGroup, getCompletedAsyncWrapperObj(successData, error)));
  }
});
const getFlightControlEpic = produceLoadLoadingLoadedEpic({
  filterOnType: loadFlightControlActionTypes.LOAD,
  loadResource: (payload) => {
    const experimentationGroup = getExperimentationGroupIdFromPath(payload.workspaceId, payload.managementGroup);
    return MdsDataplaneResources.getConfigWithTypeV2({
      // @ts-ignore
      workspaceId: payload.workspaceId,
      experimentationGroup,
      section: MasterDataConstants.flightControlSection
    });
  },
  // @ts-ignore
  loadingAction: (payload) => loadingFlightControl(payload.workspaceId, payload.managementGroup),
  loadedAction: (successData, payload, error) => {
    return of(loadedFlightControl(payload.workspaceId, payload.managementGroup, getCompletedAsyncWrapperObj(successData, error)));
  }
});
const getTrafficFiltersEpic = produceLoadLoadingLoadedEpic({
  filterOnType: loadTrafficFiltersActionTypes.LOAD,
  loadResource: (payload) => {
    const experimentationGroup = getExperimentationGroupIdFromPath(payload.workspaceId, payload.managementGroup);
    return MdsDataplaneResources.getConfigWithTypeV2({
      // @ts-ignore
      workspaceId: payload.workspaceId,
      experimentationGroup,
      section: MasterDataConstants.experimentTrafficFiltersSection
    });
  },
  // @ts-ignore
  loadingAction: (payload) => loadingTrafficFilters(payload.workspaceId, payload.managementGroup),
  loadedAction: (successData, payload, error) => {
    return of(
      // @ts-ignore
      loadedTrafficFilters(payload.workspaceId, payload.managementGroup, getCompletedAsyncWrapperObj(successData, error))
    );
  }
});
const getExperimentPrototypeEpic = produceLoadLoadingLoadedEpic({
  filterOnType: loadExperimentPrototypeActionTypes.LOAD,
  loadResource: (payload) => {
    return ExperimentResources.getPrototypeExperiment(payload.templateName, payload.workspaceId, payload.managementGroup);
  },
  // @ts-ignore
  loadingAction: (payload) => loadingExperimentPrototype(payload.workspaceId, payload.managementGroup, payload.templateName),
  loadedAction: (successData, payload, error) => {
    return of(
      // @ts-ignore
      loadedExperimentPrototype(payload.workspaceId, payload.managementGroup, getCompletedAsyncWrapperObj(successData, error))
    );
  }
});
const createExperimentEpic = produceLoadLoadingLoadedEpic({
  filterOnType: createExperimentActionTypes.LOAD,
  loadResource: (payload) => {
    return ExperimentResources.createExperiment(payload.templateName, payload.experimentConfiguration);
  },
  loadingAction: (payload) => creatingExperiment(),
  loadedAction: (successData, payload, error) => {
    return of(createdExperiment(getCompletedAsyncWrapperObj(successData, error)));
  }
});
const afterCreateExperiment = (action$) => {
  return action$.pipe(
    ofType(createExperimentActionTypes.LOADED),
    tap((action) => {
      var _a, _b;
      if (!((_a = action.payload.createdExperimentId) == null ? void 0 : _a.error) && !!action.payload.createdExperimentId.data) {
        ExperimentUtils.redirectToNewExperiment((_b = action.payload.createdExperimentId) == null ? void 0 : _b.data);
      }
    }),
    ignoreElements()
  );
};
const epic = combineEpics(
  getExpTemplatesEpic,
  getFlightControlEpic,
  getTrafficFiltersEpic,
  getExperimentPrototypeEpic,
  createExperimentEpic,
  afterCreateExperiment
);
export {
  afterCreateExperiment,
  createExperimentEpic,
  epic as default,
  getExpTemplatesEpic,
  getExperimentPrototypeEpic,
  getFlightControlEpic,
  getTrafficFiltersEpic
};
//# sourceMappingURL=ExperimentCreateContainer.epic.js.map
